/* @flow */
import React from 'react';
import { translate } from 'react-i18next';
import type { TFunction } from 'react-i18next';

type Props = {
  details: Object,
  t: TFunction,
};

export default function(props: Props) {
  if (!props.details.is_caas_customer || !props.details.is_caas_active) {
    return null;
  }

  return (
    <table>
      <tbody>
        <tr>
          <td>
            <b>{props.t('general:caas.labels.is_caas_customer')}:</b>
          </td>
          <td>{props.details.is_caas_customer ? 'Yes' : 'No'}</td>
        </tr>
        <tr>
          <td>
            <b>{props.t('general:caas.labels.is_caas_active')}:</b>
          </td>
          <td>{props.details.is_caas_active ? 'Yes' : 'No'}</td>
        </tr>
        <tr>
          <td>
            <b>{props.t('general:caas.labels.caas_customer_po')}:</b>
          </td>
          <td>{props.details.caas_customer_po}</td>
        </tr>
        <tr>
          <td>
            <b>{props.t('general:caas.labels.erp_order_id')}:</b>
          </td>
          <td>{props.details.erp_order_id}</td>
        </tr>
      </tbody>
    </table>
  );
}
